import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { lastValueFrom } from 'rxjs';

import { AuthService } from '../shared-components/ng-login/auth/auth.service';
import { UserService } from './user.service';

export const paymentEnrolmentsGuard: CanActivateFn = async () => {
  const userService = inject(UserService);
  const authService = inject(AuthService);

  let localStorageAccessAcademicServices = authService.getUserData().canAccessAcademicServices ?? false;
  if (!localStorageAccessAcademicServices) {
    const profile = await lastValueFrom(userService.profile());
    if (profile?.canAccessAcademicServices) {
      userService.updateUserStorage(profile);
      localStorageAccessAcademicServices = true;
    }
  }

  return localStorageAccessAcademicServices;
};
